import script from "./CalendarDesktop.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarDesktop.vue?vue&type=script&setup=true&lang=js"

import "./CalendarDesktop.vue?vue&type=style&index=0&id=5e43dea4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e43dea4"]])

export default __exports__